import { css } from 'styled-components';

const focusColor = css(["", ""], _ref => {
  let {
    theme
  } = _ref;
  return theme.k.color.status.blue;
});
/**
 * Show a custom focus outline style.
 */
const focusOutline = css(["outline:none;box-shadow:0 0 0 2px #fff,0 0 0 4px ", ",0 0 0 6px #fff;"], focusColor);

export { focusOutline };
